// src/pages/customers/customerDetails.tsx
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { getProfileById, updateProfile } from "../../services/profileService";
import { Icon } from "@iconify/react";
import Modal from "../../components/Modal";
import { deleteProfile } from "../../services/profileService";
import Button from "../../components/Button";
import { toast } from "react-hot-toast"; // optional for success/error messages
import FormBuilder, { FieldConfig } from "../../components/FormBuilder";
import { customerFields } from "./CusFormFields";
import { flattenProfile } from "../../services/mappers";
import AddressBankDetails from "../../components/ProfileDatas/AddressBankDetails";
import VehicleDetails from "../../components/ProfileDatas/VehicleDetails";
import { useAuth } from "../../context/AuthContext";
import { objectToFormData } from "../../utils/objectToFormData";

type TabKey = 'personal' | 'address' | 'loans' | 'vehicle';


export default function CustomerDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const stateId = location.state?.id;
  const authProfileId = user?.profile?.profile_id ?? user?.profile_id; // adjust to your user shape

  const id = stateId || authProfileId;
  const [menuOpen, setMenuOpen] = useState(false);
  const [customer, setcustomer] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const menuRef = useRef<HTMLDivElement>(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string[]> | null>(null);
  const [editingcustomer, setEditingcustomer] = useState<any>(null);
  // Tabs 
  // const [activeTab, setActiveTab] = useState<TabKey>('loans');
  const [activeTab, setActiveTab] = useState<TabKey>(() => location.state?.activeTab || 'loans');

  const isAdmin = user?.role === "Admin";
  const isCustomer = user?.role === "Customer";

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state?.activeTab]);


  const editableFields = [
    "email",
    "mobile_number",
    "first_name",
    "last_name",
    "date_of_birth",
    "gender",
    "marital_status",
    "father_name",
    "mother_name",
    "spouse_name",
    "aadhaar_number",
    "pan_number",
    "driving_license",
    "voter_id",
    "passport_number",
    "salary",
    "employment_type",
    "employer_name",
    "work_experience",
    "credit_score",
    "monthly_income",
    "other_liabilities",
    "status",
    "profile_photo",
    "sign_photo",
    "profile_photo_url",
    "sign_photo_url"
  ];

  // small reusable Tab button
  function TabButton({ tabKey, label }: { tabKey: TabKey; label: string }) {
    const active = activeTab === tabKey;
    return (
      <button
        onClick={() => setActiveTab(tabKey)}
        className={`relative px-4 py-2 font-medium text-sm transition-colors duration-200 cursor-pointer text-nowrap
        ${active ? 'text-indigo-600' : 'text-gray-600 hover:text-indigo-600'}
      `}
      >
        {label}
        {active && (
          <span className="absolute left-0 right-0 -bottom-0 h-[2px] bg-indigo-600 rounded-full"></span>
        )}
      </button>
    );
  }

  const handleEditClick = async () => {
    if (!customer) return;

    // Build the initial edit payload from existing customer data
    try {
      const localFlattened =
        customer.profile_id || customer.login
          ? flattenProfile(customer) // keep same shape your FormBuilder expects
          : customer;
      const merged = {
        ...localFlattened,
        loans: customer.loans ?? localFlattened.loans ?? [],
        address_bank_details: customer.address_bank_details ?? localFlattened.address_bank_details ?? [],
        vehicles: customer.vehicles ?? localFlattened.vehicles ?? [],

        login: customer.login ?? localFlattened.login ?? {},
      };

      setEditingcustomer(merged);
      setFormErrors(null);
      setEditModalOpen(true);
    } catch (err) {
      console.error("Failed to prepare edit data", err);
      toast.error("Failed to prepare edit form");
    }
  };


  const fetchcustomer = async () => {

    try {
      const res = await getProfileById(id);
      setcustomer(res.profile);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }

  }


  useEffect(() => {
    if (!id) {
      navigate("/customers");
      return;
    }



    fetchcustomer();
  }, [id, navigate]);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    }

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  if (loading) return (
    <div className="flex justify-center items-center py-12">
      <span className="animate-spin mr-2">
        <svg className="h-6 w-6 text-sky-500" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
        </svg>
      </span>
      <span className="text-slate-500">Loading...</span>
    </div>
  );
  if (!customer) return <div>customer not found</div>;

  const login = customer.login;

  const handleDeleteClick = () => {
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!id) return;
    setDeleting(true);
    try {
      const res = await deleteProfile(id);
      toast.success(res.message || "Profile deleted successfully!");
      setDeleteModalOpen(false);
      navigate("/customers"); // go back to list after deletion
    } catch (err: any) {
      console.error(err);
      toast.error(err?.response.data.message || "Failed to delete customer");
    } finally {
      setDeleting(false);
    }
  };

      const formatDate = (isoDate: string) => {
  if (!isoDate) return "";

  const date = new Date(isoDate);
if (isNaN(date.getTime())) return "—";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

  return (
    <div className=" mx-auto ">
      {/* Header */}
      {!isCustomer && (<div className="flex items-center justify-between main-bg sticky top-0 ps-2 pt-2 pb-2 px-0  z-10">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3 py-1 rounded-xl bg-white hover:bg-gray-200 text-gray-700 font-medium shadow-sm transition-all duration-150 cursor-pointer"
          >
            <Icon icon="mdi:arrow-left" width={18} />
            <span className="hidden md:block " ref={menuRef}>Back</span>
          </button>

          <h3 className="text-lg font-semibold text-gray-800">customer Details</h3>
        </div>



        {/* Desktop Buttons */}
        <div className="hidden md:flex gap-3 items-center">
          {!isCustomer && (<button onClick={handleEditClick} className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-1 bg-white rounded-lg border-2 border-slate-200 cursor-pointer">
            <Icon icon="mdi:pencil" width={16} />
            Edit
          </button>)}
          {
            //  isAdmin 
            // && (
            // <button onClick={handleDeleteClick} className="flex-1 inline-flex items-center justify-center gap-2 px-3 py-2 rounded-lg border border-rose-200 text-rose-600 cursor-pointer">
            //   <Icon icon="mdi:delete" width={16} />
            //   Delete
            // </button>
            //  )
          }
        </div>

        {/* Mobile Three-Dot Menu */}
        <div className="md:hidden relative" ref={menuRef}>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className=" rounded-full hover:bg-gray-200 transition"
          >
            <Icon icon="mdi:dots-vertical" width={24} />
          </button>

          {menuOpen && (
            <div className="absolute right-0 mt-2 w-32 bg-white border rounded-lg shadow-lg z-50">
              <button onClick={handleEditClick} className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-2 ">
                <Icon icon="mdi:pencil" width={16} />
                Edit
              </button>
              {
                // isAdmin && (<button onClick={handleDeleteClick} className="w-full text-left px-4 py-2 hover:bg-gray-100 flex items-center gap-2 text-rose-600">
                //   <Icon icon="mdi:delete" width={16} />
                //   Delete
                // </button>)
              }
            </div>
          )}
        </div>
      </div>)}



      <div className="px-2 mt-4">
        <div className="flex flex-col md:flex-row items-center gap-4 mb-6  bg-white p-4 rounded-xl shadow col-span-2 md:col-span-2">
          {customer.profile_photo_url ? (
            <img
              src={customer.profile_photo_url ? `${customer.profile_photo_url}` : "/assets/avatar.png"}
              alt={customer.first_name}
              className="w-24 h-24 md:w-32 md:h-32 rounded-full object-cover"
            />
          ) : (
            <div className="w-24 h-24 md:w-32 md:h-32 rounded-full flex items-center justify-center bg-blue-500">
              <span className="text-white font-semibold text-3xl">
                {(customer.first_name?.charAt(0) ?? "?").toUpperCase()}
              </span>
            </div>
          )
          }
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl font-bold">
              {customer.first_name} {customer.last_name}
            </h2>
            <p className="text-gray-500">{customer.customer_code}</p>
            <p><strong></strong> {customer?.email ?? "—"}</p>
            <div className="mt-2 flex flex-col md:flex-row md:items-center gap-4 ">
              <p className={`p-1 px-3  rounded-full  font-medium ${customer.status === "Active" ? "text-green-800 bg-green-100" : "text-red-500 bg-red-100"}`}>
                {customer.status}
              </p>
              <p className="p-1 px-3 bg-blue-100 rounded-full text-blue-800 font-medium">{login?.role ?? "—"}</p>
            </div>
          </div>
        </div>



        {/* Tabs header */}
        <div className=" px-2 mb-3 border-b border-gray-200">
          <div className="overflow-x-auto flex">
            <TabButton tabKey="loans" label="Loans" />
            <TabButton tabKey="vehicle" label="Vehicle" />
            <TabButton tabKey="address" label="Address" />
            <TabButton tabKey="personal" label="Personal Info" />

          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-3">

          {/* PERSONAL TAB */}
          {activeTab === 'personal' && (
            <>
              {/* Personal Details */}
              <div className="bg-white p-4 rounded-xl shadow mb-4 col-span-2 md:col-span-1">
                <h3 className="text-xl font-semibold pb-3 mb-2 gap-3 border-b border-gray-200">Personal Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <p><strong>Mobile No:</strong> {customer?.mobile_number ?? "—"}</p>
                  <p><strong>Date of Birth:</strong> {formatDate(customer.date_of_birth )}</p>
                  <p><strong>Gender:</strong> {customer.gender ?? "—"}</p>
                  <p><strong>Marital Status:</strong> {customer.marital_status ?? "—"}</p>
                  <p><strong>Father Name:</strong> {customer.father_name ?? "—"}</p>
                  <p><strong>Mother Name:</strong> {customer.mother_name ?? "—"}</p>
                  <p><strong>Spouse Name:</strong> {customer.spouse_name ?? "—"}</p>
                  <p><strong>Aadhaar:</strong> {customer.aadhaar_number ?? "—"}</p>
                  <p><strong>PAN:</strong> {customer.pan_number ?? "—"}</p>
                  <p><strong>Driving License:</strong> {customer.driving_license ?? "—"}</p>
                  <p><strong>Voter ID:</strong> {customer.voter_id ?? "—"}</p>
                  <p><strong>Passport:</strong> {customer.passport_number ?? "—"}</p>
                </div>
              </div>

              {/* Employment & Finance Details */}
              <div className="bg-white p-4 rounded-xl shadow mb-4 col-span-2 md:col-span-1">
                <h3 className="text-xl font-semibold pb-3 mb-2 gap-3 border-b border-gray-200">Employment & Finance</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <p><strong>Employment Type:</strong> {customer.employment_type ?? "—"}</p>
                  {/* <p><strong>Employer Name:</strong> {customer.employer_name ?? "—"}</p> */}
                  <p><strong>Work Experience (years):</strong> {customer.work_experience ?? "—"}</p>
                  {/* <p><strong>Salary:</strong> {customer.salary ?? "—"}</p> */}
                  <p><strong>Monthly Income:</strong> {customer.monthly_income ?? "—"}</p>
                  <p><strong>Other Liabilities:</strong> {customer.other_liabilities ?? "—"}</p>
                  <p><strong>Credit Score:</strong> {customer.credit_score ?? "—"}</p>
                </div>
              </div>

              {/* Signature*/}

              <div className="bg-white p-4 rounded-xl shadow flex flex-col items-center col-span-2 md:col-span-2">
                <h3 className="text-lg font-semibold mb-2 border-b border-gray-200">Signature</h3>

                {customer.sign_photo_url ? (
                  <img
                    src={`${customer.sign_photo_url}`}
                    alt="Signature"
                    className="w-48 h-16 object-contain"
                  />
                ) : (
                  <div className="w-48 h-16 flex items-center justify-center border-2 border-dashed border-gray-300 rounded text-gray-400 font-medium">
                    No Signature Available
                  </div>
                )}
              </div>
            </>
          )}




          {/* ADDRESS TAB */}
          {activeTab === "address" && (
            <div className="col-span-2">
              <AddressBankDetails
                profileId={customer.profile_id ?? customer.id}
                addressBank={customer.address_bank_details ?? []}
                onChange={(newList) =>
                  setcustomer((prev: any) => ({ ...prev, address_bank_details: newList }))
                }
              />
            </div>
          )}


          {/* vehicle TAB */}
          {activeTab === "vehicle" && (
            <div className="col-span-2">
              <VehicleDetails
                profileId={customer.profile_id ?? customer.id}
                vehicles={customer.vehicles ?? []}
              onChange={(newList) => {
                  setcustomer((prev: any) => ({ ...prev, vehicles: newList }));
                  fetchcustomer();
                }}
              />
            </div>
          )}




          {/* LOANS TAB */}
          {activeTab === 'loans' && (
            <div className="col-span-2">
              <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100">
                <h3 className="text-xl font-semibold mb-4 border-b border-gray-200 pb-2 flex items-center justify-between">
                  <span>Loans</span>
                  {customer.loans?.length > 0 && (
                    <span className="text-sm text-gray-500">
                      Total: {customer.loans.length}
                    </span>
                  )}
                </h3>

                {customer.loans?.length > 0 ? (
                  <div className="space-y-5">
                    {customer.loans.map((loan: any, idx: number) => (
                      <div
                        key={idx}
                        className="group bg-white  rounded-2xl border border-gray-200 hover:border-indigo-400 hover:shadow-md transition-all duration-200 cursor-pointer overflow-hidden"
                        onClick={() =>
                          navigate("/loan-dues", { state: { loan_id: loan.loan_id } })
                        }
                      >
                        {/* Header */}
                        <div className="flex justify-between items-center mb-4 p-5  bg-[#F6F8FD]">
                          <h3 className="text-xl font-semibold text-indigo-600">
                            {loan.repayment_frequency
                              ? `Payment: ${loan.repayment_frequency}`
                              : `Loan ${idx + 1}`}
                          </h3>

                          <Icon
                            icon="iconamoon:arrow-right-2-light"
                            width={22}
                            className="text-gray-400 group-hover:text-indigo-600 transition"
                          />
                        </div>

                        {/* Loan Details */}
                        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 text-sm p-5 pt-0">
                          <div>
                            <span className="text-gray-500 block mb-1">Loan Code</span>
                            <span className="font-medium text-gray-800">
                              {loan.loan_code ?? "—"}
                            </span>
                          </div>

                          <div>
                            <span className="text-gray-500 block mb-1">Loan Amount</span>
                            <span className="font-medium text-gray-800">
                              ₹{loan.loan_amount ?? "—"}
                            </span>
                          </div>

                          <div>
                            <span className="text-gray-500 block mb-1">Disbursed</span>
                            <span className="font-medium text-gray-800">
                              ₹{loan.disbursed_amount ?? "—"}
                            </span>
                          </div>

                          <div>
                            <span className="text-gray-500 block mb-1">Start Date</span>
                            <span className="font-medium text-gray-800">
                              {loan.start_date ?? "—"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-gray-500 italic text-sm">No loans available</div>
                )}

              </div>
            </div>
          )}


        </div>

        <Modal
          isOpen={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          title="Edit customer"
        >


          <FormBuilder
            defaultValues={editingcustomer}
            fields={
              customerFields
                .filter((field): field is Extract<FieldConfig, { name: string }> => "name" in field) // narrow
                .filter((field) => editableFields.includes(field.name) || field.name === "username")
                .map((field) => (field.name === "username" ? { ...field, readOnly: true } : field))
            }
            onSubmit={async (formData) => {
              if (!customer) return;

              try {
                const idToUse = customer.profile_id ?? customer.id;

                // Only send editable fields
                const filtered: any = {};
                editableFields.forEach((key) => {
                  if (formData[key] !== undefined) {
                    filtered[key] = formData[key];
                  }
                });

                // 🔑 REMOVE image fields if they are NOT files
                ["profile_photo", "sign_photo"].forEach((imgKey) => {
                  const v = filtered[imgKey];
                  const isFile = v instanceof File || (v instanceof FileList && v.length > 0);
                  if (!isFile) delete filtered[imgKey];
                });


                const fd = objectToFormData(filtered);

                const res = await updateProfile(idToUse, fd);

                toast.success(res.message || "Customer updated successfully!");
                setEditModalOpen(false);
                fetchcustomer();

              } catch (err: any) {
                const errorData = err?.response?.data;
                setFormErrors(errorData?.errors ?? null);
                toast.error(errorData?.message || "Failed to update customer");
              }
            }}

            onCancel={() => setEditModalOpen(false)}
            error={formErrors}
            submitLabel="Update customer"
          />

        </Modal>



        <Modal
          isOpen={deleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          title="Confirm Delete"
        >
          <p className="mb-5 text-gray-700">
            Are you sure you want to delete{" "}
            <span className="font-semibold">
              {customer?.first_name} {customer?.last_name}
            </span>?
          </p>
          <div className="flex justify-end gap-3">
            <Button
              variant="secondary"
              onClick={() => setDeleteModalOpen(false)}
              disabled={deleting}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={confirmDelete}
              disabled={deleting}
            >
              {deleting ? "Deleting..." : "Delete"}
            </Button>
          </div>
        </Modal>
      </div>

    </div>

  );
}
